export default {
    SET_POSTS(state, posts) {
        state.posts = posts
    },
    SET_FAVOURITE_ACCOUNTS(state, accounts) {
        state.favouriteAccounts = accounts
    },
    ADD_FAVOURITE_ACCOUNT(state, account) {
        if (state.favouriteAccounts.any((a) => a.id === account.id)) {
            return
        }
        state.favouriteAccounts.push({
            id: account.id,
            name: account.name
        })
    },
    REMOVE_FAVOURITE_ACCOUNT(state, accountId) {
        state.favouriteAccounts.removeWhere((f) => f.id === accountId)
    },
    SET_COLORS(state, colors) {
        Object.assign(state.theme.colors, colors)
        this._vm.$vs.theme(colors)
    },
    SET_PRIMARY_COLOR(state, color) {
        state.theme.colors.primary = color
        this._vm.$vs.theme({ primary: color })
    },
    SET_LAYOUT_PREFERENCE(state, layout) {
        state.theme.mainLayoutType = layout
    },
    SET_THEME_PREFERENCE(state, val) {
        state.theme.theme = val
    },
    SET_NAVBAR_COLOR(state, val) {
        state.theme.navbarColor = val
    },
    SET_NAVBAR_TYPE(state, val) {
        state.theme.navbarType = val
    },
    TOGGLE_COLLAPSABLE_SIDEBAR(state, val) {
        if (val == null) {
            state.theme.sidebarCollapsed = !state.theme.sidebarCollapsed
        } else {
            state.theme.sidebarCollapsed = val
        }
    },
    TOGGLE_SIDEBAR(state, val) {
        if (val == null) {
            state.theme.sidebarCollapsed = !state.theme.sidebarCollapsed
        } else {
            state.theme.sidebarCollapsed = val
        }
    }
}
